/* Paid-traffic prompt. Posts the existing Scent Drop customer form. */
(function (root) {
  'use strict';

  var HIDE_KEY = 'kakaraSoftDropHideUntil';
  var PAID_KEY = 'kakaraPaidVisit';
  var LANDING_KEY = 'kakaraPaidLanding';
  var ONE_DAY_MS = 24 * 60 * 60 * 1000;
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
  var OPEN_DELAY_MS = 2000;
  var CLICK_IDS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'];
  var PAID_SOURCES = {
    facebook: true,
    fb: true,
    instagram: true,
    ig: true,
    meta: true,
    google: true,
    adwords: true,
    googleads: true,
    google_ads: true
  };
  var ORGANIC_MEDIUMS = {
    organic: true,
    organic_social: true,
    social: true,
    email: true,
    newsletter: true,
    referral: true
  };

  function normalizePath(path) {
    if (!path) return '';
    if (path.length > 1 && path.charAt(path.length - 1) === '/') return path.slice(0, -1);
    return path;
  }

  function readParams(search) {
    var raw = search || '';
    if (raw.charAt(0) === '?') raw = raw.slice(1);
    var params = new URLSearchParams(raw);
    var out = {};
    params.forEach(function (value, key) {
      var name = String(key || '').toLowerCase();
      if (!out[name]) out[name] = value;
    });
    return out;
  }

  function normalizeToken(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  }

  function isPaidMedium(medium) {
    if (!medium) return false;
    if (medium === 'cpc' || medium === 'ppc') return true;
    return medium === 'paid' || medium.indexOf('paid_') === 0;
  }

  function isPaidSearch(search, allowPreview) {
    var params = readParams(search);
    var i;
    for (i = 0; i < CLICK_IDS.length; i += 1) {
      if (params[CLICK_IDS[i]]) return true;
    }
    // Local and unpublished theme preview only. Live (role main) does not set allowPreview.
    if (allowPreview && params.kakara_ad === '1') return true;
    var medium = normalizeToken(params.utm_medium);
    if (ORGANIC_MEDIUMS[medium]) return false;
    var source = normalizeToken(params.utm_source);
    return !!(PAID_SOURCES[source] || isPaidMedium(medium));
  }

  function shouldOffer(state) {
    if (!state || state.customerPosted || !state.paid || !state.hasForm) return false;
    if (!state.previewForce && state.hideUntil && state.now < state.hideUntil) return false;
    return true;
  }

  if (!root.document) {
    root.__kakaraSoftDropTest = {
      isPaidSearch: isPaidSearch,
      normalizePath: normalizePath,
      shouldOffer: shouldOffer
    };
    return;
  }

  var document = root.document;
  var popup = document.querySelector('[data-soft-drop]');
  if (!popup) return;

  function storageGet(store, key) {
    try {
      return store.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(store, key, value) {
    try {
      store.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function templateName() {
    var className = document.body ? document.body.className : '';
    if (/(?:^|\s)template-index(?:\s|$)/.test(className)) return 'index';
    if (/(?:^|\s)template-product(?:\s|$)/.test(className)) return 'product';
    var match = className.match(/(?:^|\s)template-([a-z0-9]+)/);
    return match ? match[1] : '';
  }

  function tagsOf(form) {
    var input = form.querySelector('input[name="contact[tags]"]');
    if (!input) return [];
    return input.value.split(',').map(function (part) {
      return part.trim().toLowerCase();
    }).filter(Boolean);
  }

  function isScentDropForm(form) {
    if (!form) return false;
    var type = form.querySelector('input[name="form_type"][value="customer"]');
    if (!type) return false;
    return tagsOf(form).indexOf('newsletter') !== -1;
  }

  function findScentDropForm() {
    var preferred = document.querySelector('#scent-drop form');
    if (isScentDropForm(preferred)) return preferred;
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i += 1) {
      if (isScentDropForm(forms[i])) return forms[i];
    }
    return null;
  }

  var allowPreview = popup.getAttribute('data-soft-drop-preview') === 'true';
  var previewForce = allowPreview && new URLSearchParams(root.location.search).get('kakara_ad') === '1';

  function rememberPaidVisit() {
    var paidNow = isPaidSearch(root.location.search, allowPreview);
    if (paidNow) {
      storageSet(root.sessionStorage, PAID_KEY, '1');
      if (!storageGet(root.sessionStorage, LANDING_KEY)) {
        storageSet(root.sessionStorage, LANDING_KEY, normalizePath(root.location.pathname));
      }
    }
    return paidNow || storageGet(root.sessionStorage, PAID_KEY) === '1';
  }

  function hideUntil() {
    var raw = storageGet(root.localStorage, HIDE_KEY);
    var until = raw ? Number(raw) : 0;
    return Number.isFinite(until) ? until : 0;
  }

  function rememberHide(durationMs) {
    storageSet(root.localStorage, HIDE_KEY, String(Date.now() + durationMs));
  }

  function customerJustPosted() {
    return new URLSearchParams(root.location.search).get('customer_posted') === 'true';
  }

  function overlayOpen() {
    return !!(
      document.querySelector('.cart-drawer.is-active') ||
      document.querySelector('.header__mobile-nav.is-active') ||
      document.querySelector('.header__search.is-active') ||
      document.querySelector('dialog[open]')
    );
  }

  var form = findScentDropForm();
  var paid = rememberPaidVisit();
  if (customerJustPosted()) rememberHide(THIRTY_DAYS_MS);

  if (!shouldOffer({
    customerPosted: customerJustPosted(),
    paid: paid,
    hasForm: !!form,
    hideUntil: hideUntil(),
    previewForce: previewForce,
    now: Date.now(),
    templateName: templateName(),
    pathname: root.location.pathname,
    landingPath: storageGet(root.sessionStorage, LANDING_KEY) || ''
  })) {
    return;
  }

  var entry = popup.querySelector('[data-soft-drop-entry]');
  var panel = popup.querySelector('[data-soft-drop-panel]');
  var emailInput = popup.querySelector('[data-soft-drop-email]');
  var errorEl = popup.querySelector('[data-soft-drop-error]');
  var successEl = popup.querySelector('[data-soft-drop-success]');
  var submitButton = popup.querySelector('[data-soft-drop-submit]');
  var openTimer = 0;
  var closeTimer = 0;
  var watchTimer = 0;
  var opened = false;
  var paused = false;
  var succeeded = false;
  var previousFocus = null;

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function setError(show) {
    if (!errorEl) return;
    errorEl.hidden = !show;
    if (emailInput) emailInput.setAttribute('aria-invalid', show ? 'true' : 'false');
  }

  function lockScroll(lock) {
    document.body.classList.toggle('soft-drop-open', lock);
  }

  function closePopup() {
    opened = false;
    paused = false;
    popup.hidden = true;
    lockScroll(false);
    root.clearInterval(watchTimer);
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  }

  function dismiss() {
    if (!succeeded) rememberHide(ONE_DAY_MS);
    root.clearTimeout(closeTimer);
    closePopup();
  }

  function hiddenByDismiss() {
    return !previewForce && hideUntil() > Date.now();
  }

  function showPopup() {
    if (opened || hiddenByDismiss()) return;
    opened = true;
    paused = false;
    previousFocus = document.activeElement;
    popup.hidden = false;
    lockScroll(true);
    if (emailInput) emailInput.focus({ preventScroll: true });
    watchTimer = root.setInterval(syncOverlay, 300);
  }

  function syncOverlay() {
    if (!opened || succeeded) return;
    var blocked = overlayOpen();
    if (blocked && !paused) {
      paused = true;
      popup.hidden = true;
      lockScroll(false);
    } else if (!blocked && paused) {
      paused = false;
      popup.hidden = false;
      lockScroll(true);
      if (emailInput) emailInput.focus({ preventScroll: true });
    }
  }

  function tryOpen() {
    if (hiddenByDismiss()) return;
    if (overlayOpen()) {
      openTimer = root.setTimeout(tryOpen, 400);
      return;
    }
    showPopup();
  }

  function withSoftDropTag(value) {
    var parts = String(value || '').split(',').map(function (part) {
      return part.trim();
    }).filter(Boolean);
    var hasSoftDrop = parts.some(function (part) {
      return part.toLowerCase() === 'soft-drop';
    });
    if (!hasSoftDrop) parts.push('soft-drop');
    return parts.join(',');
  }

  function bindCaptcha(target) {
    var captcha = root.Shopify && root.Shopify.captcha;
    if (target.getAttribute('data-hcaptcha-bound') === 'true') return;
    if (captcha && typeof captcha.protect === 'function') {
      try {
        captcha.protect(target);
      } catch (error) {
        /* Existing form submit still binds on focus. */
      }
    }
    var field = target.querySelector('input[type="email"]');
    if (field) {
      field.dispatchEvent(new Event('focusin', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function whenCaptchaBound(target) {
    if (target.getAttribute('data-hcaptcha-bound') === 'true') return Promise.resolve(true);
    return new Promise(function (resolve) {
      var start = Date.now();
      var timer = root.setInterval(function () {
        if (target.getAttribute('data-hcaptcha-bound') === 'true' || Date.now() - start > 8000) {
          root.clearInterval(timer);
          resolve(target.getAttribute('data-hcaptcha-bound') === 'true');
        }
      }, 40);
    });
  }

  function postedOk(response, html) {
    var url = response && response.url ? response.url : '';
    if (/[?&]customer_posted=true(?:&|#|$)/.test(url)) return true;
    return html.indexOf('footer__newsletter-success') !== -1 ||
      html.indexOf('newsletter__success') !== -1 ||
      html.indexOf('collection-category-coming-soon__message--success') !== -1;
  }

  function showSuccess() {
    succeeded = true;
    rememberHide(THIRTY_DAYS_MS);
    setError(false);
    if (entry) entry.hidden = true;
    if (successEl) {
      successEl.hidden = false;
      successEl.focus({ preventScroll: true });
    }
    closeTimer = root.setTimeout(closePopup, 2200);
  }

  function submitExistingForm(email) {
    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    var existingEmail = form.querySelector('input[type="email"][name="contact[email]"]');
    if (!tagsInput || !existingEmail) return Promise.reject(new Error('form'));

    tagsInput.setAttribute('data-soft-drop-previous-tags', tagsInput.value);
    existingEmail.setAttribute('data-soft-drop-previous-email', existingEmail.value);
    tagsInput.value = withSoftDropTag(tagsInput.value);
    existingEmail.value = email;
    form.setAttribute('data-soft-drop-intercept', '1');

    bindCaptcha(form);

    return whenCaptchaBound(form).then(function (bound) {
      if (!bound || typeof form.requestSubmit !== 'function') {
        throw new Error('captcha');
      }
      return new Promise(function (resolve, reject) {
        var settled = false;
        function restoreFields() {
          if (tagsInput.hasAttribute('data-soft-drop-previous-tags')) {
            tagsInput.value = tagsInput.getAttribute('data-soft-drop-previous-tags');
            tagsInput.removeAttribute('data-soft-drop-previous-tags');
          }
          if (existingEmail.hasAttribute('data-soft-drop-previous-email')) {
            existingEmail.value = existingEmail.getAttribute('data-soft-drop-previous-email');
            existingEmail.removeAttribute('data-soft-drop-previous-email');
          }
        }
        function finish(submitted) {
          if (settled) return;
          settled = true;
          root.__kakaraSoftDropFinish = null;
          var body = new URLSearchParams();
          var data = new FormData(submitted);
          data.forEach(function (value, key) {
            body.append(key, value);
          });
          restoreFields();
          var action = (submitted.getAttribute('action') || '/contact').split('#')[0];
          root.fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              Accept: 'text/html'
            },
            body: body.toString(),
            credentials: 'same-origin',
            redirect: 'follow'
          }).then(function (response) {
            return response.text().then(function (html) {
              return { response: response, html: html };
            });
          }).then(function (result) {
            if (!postedOk(result.response, result.html)) throw new Error('signup');
            resolve();
          }).catch(reject);
        }
        root.__kakaraSoftDropFinish = finish;
        root.setTimeout(function () {
          if (settled) return;
          settled = true;
          form.setAttribute('data-soft-drop-intercept', 'done');
          restoreFields();
          root.__kakaraSoftDropFinish = null;
          reject(new Error('timeout'));
        }, 20000);
        form.requestSubmit();
      });
    }).catch(function (error) {
      form.setAttribute('data-soft-drop-intercept', 'done');
      if (tagsInput.hasAttribute('data-soft-drop-previous-tags')) {
        tagsInput.value = tagsInput.getAttribute('data-soft-drop-previous-tags');
        tagsInput.removeAttribute('data-soft-drop-previous-tags');
      }
      if (existingEmail.hasAttribute('data-soft-drop-previous-email')) {
        existingEmail.value = existingEmail.getAttribute('data-soft-drop-previous-email');
        existingEmail.removeAttribute('data-soft-drop-previous-email');
      }
      throw error;
    });
  }

  function onSubmit() {
    if (succeeded || !emailInput || !submitButton) return;
    var email = emailInput.value.trim();
    if (!validEmail(email)) {
      setError(true);
      emailInput.focus({ preventScroll: true });
      return;
    }
    setError(false);
    submitButton.disabled = true;
    submitExistingForm(email).then(function () {
      if (!opened) return;
      if (overlayOpen()) {
        rememberHide(THIRTY_DAYS_MS);
        closePopup();
        return;
      }
      showSuccess();
    }).catch(function () {
      submitButton.disabled = false;
      if (!popup.hidden) setError(true);
    });
  }

  function onKeydown(event) {
    if (!opened || popup.hidden) return;
    if (event.key !== 'Tab' || !panel) return;
    var nodes = panel.querySelectorAll('input, button, a, [tabindex]');
    var focusable = [];
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.disabled || node.closest('[hidden]')) continue;
      focusable.push(node);
    }
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  var dismissButton = popup.querySelector('[data-soft-drop-dismiss]');
  if (dismissButton) dismissButton.addEventListener('click', dismiss);
  if (submitButton) submitButton.addEventListener('click', onSubmit);
  if (emailInput) {
    emailInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        onSubmit();
      }
    });
  }
  document.addEventListener('keydown', onKeydown);

  openTimer = root.setTimeout(tryOpen, OPEN_DELAY_MS);
})(typeof window !== 'undefined' ? window : globalThis);
